import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getBitbucketAuth } from 'api';

// Then, handle actions in your reducers:
const bitbucketAuthSlice = createSlice({
  name: 'bitbucketAuth',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    bitbucketAuthFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    bitbucketAuthFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    bitbucketAuthFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    bitbucketAuthResetState: (state) => {
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  bitbucketAuthFetchStart,
  bitbucketAuthFetchSuccess,
  bitbucketAuthFetchFail,
  bitbucketAuthResetState,
} = bitbucketAuthSlice.actions;

// The reducer
export const bitbucketAuthReducer = bitbucketAuthSlice.reducer;

// Asynchronous thunk action
export const bitbucketAuthFetch = (repoSlug: string) => (dispatch) => {
  dispatch(bitbucketAuthFetchStart());

  getBitbucketAuth(repoSlug)
    .then((bitbucketAuth) => {
      dispatch(bitbucketAuthFetchSuccess(bitbucketAuth.data));
    })
    .catch((error) => {
      dispatch(bitbucketAuthFetchFail(error));
    });
};
